import { CONTACT_METHODS } from 'settings/constants/contacts'

type BillingEmailContact = {
  deactivated?: boolean
  contactMethods?: { methodType?: string; methodValue?: string; billingNotifications?: boolean }[]
}

// Mirrors who the invoice senders email: active account contacts with a non-blank billing email.
export const hasBillingEmail = (contacts?: BillingEmailContact[] | null) =>
  (contacts ?? []).some(
    ({ deactivated, contactMethods }) =>
      !deactivated &&
      (contactMethods ?? []).some(
        ({ methodType, methodValue, billingNotifications }) =>
          Boolean(billingNotifications) && methodType?.toLowerCase() === CONTACT_METHODS.EMAIL.toLowerCase() && Boolean(methodValue?.trim())
      )
  )
